
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ResourcesHeroSection from './components/ResourcesHeroSection';
import DownloadableResourcesSection from './components/DownloadableResourcesSection';
import VirtualTourSection from './components/VirtualTourSection';
import HelpfulLinksSection from './components/HelpfulLinksSection';
import FAQPreviewSection from './components/FAQPreviewSection';

export default function ResourcesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <ResourcesHeroSection />
        <DownloadableResourcesSection />
        <VirtualTourSection />
        <HelpfulLinksSection />
        <FAQPreviewSection />
      </main>
      <Footer />
    </div>
  );
}
